import { addStream } from '../../epicStore'
import { merge, fromEvent, Observable } from 'rxjs'
import { pluck, map, tap } from 'rxjs/operators'
import { StateObservable, ofType } from 'redux-observable'
import { State, ReduxAction } from '../../../reducers/reducerType'
import { addSeatEntry, updateSeatEntry, removeSeatEntry, seatingOrderSyncListenersAdded } from '../../../actions/seatingOrder/seatingOrderActions'
import { DocsType } from '../../../actions/docs/docsTypes'
import { SyncMap, SyncMapItem } from 'twilio-sync'

export const events$ = (syncMap: SyncMap) => merge(
  fromEvent<{ item: SyncMapItem, isLocal: boolean }>(syncMap, 'itemAdded')
    .pipe(
      map(entry => addSeatEntry(entry))
    ),
  fromEvent<{ item: SyncMapItem, isLocal: boolean }>(syncMap, 'itemUpdated')
    .pipe(
      map(entry => updateSeatEntry(entry))
    ),
  fromEvent<{ key: string, isLocal: boolean, value: {} }>(syncMap, 'itemRemoved')
    .pipe(
      map(entry => removeSeatEntry(entry))
    )
)

const addSeatingOrderEvents$ = (actions$, state: StateObservable<State>) => actions$.pipe(
  ofType(DocsType.SET_SEATING_ORDER_MAP),
  pluck('payload'),
  map((syncMap: SyncMap) => events$(syncMap)),
  tap((stream$: Observable<ReduxAction>) => addStream(stream$)),
  map(() => seatingOrderSyncListenersAdded())
)

export default addSeatingOrderEvents$
